import { useState } from 'react';
import { Box, Stack } from '@chakra-ui/react';
import UserGrid from 'components/User/UserGrid/UserGrid';
import { useUsers } from 'hooks/queries/useUsers';

export default function UsersOverviewView() {
  const [page, setPage] = useState(1);
  const { data: paginatedUsers, isLoading } = useUsers({ page });

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  return (
    <Box maxWidth="1200px" width="100%" paddingTop={['80px', '100px', '100px']} justifySelf="center" minHeight="100vh" mx="auto">
      <Stack spacing={6}>
        <UserGrid
          paginatedUsers={paginatedUsers}
          isLoading={isLoading}
          page={page}
          onPageChange={handlePageChange}
        />
      </Stack>
    </Box>
  );
}
